import Head from 'next/head'
import { useRouter } from 'next/router'

import { useStaticData } from '@mc/static-data-react'

import { getUrlWithoutQueryParams } from 'libs/utils'
import { SITE_NAME, TWITTER_CARD, TWITTER_HANDLE } from 'libs/constants'

const Meta = () => {
  const { course, chapter } = useStaticData()
  const { asPath } = useRouter()
  const title = `${chapter.title} | ${course.title} | MasterClass`

  return (
    <Head>
      <title>{title}</title>
      <meta content={chapter.abstract} name='description' />
      <meta content={chapter.topic?.replace(' ·', ',')} name='keywords' />

      <meta content={getUrlWithoutQueryParams(asPath)} property='og:url' />
      <meta content={SITE_NAME} property='og:site_name' />
      <meta content={chapter.title} property='og:title' />
      <meta content={chapter.abstract} property='og:description' />
      <meta content={chapter.videoThumbUrl} property='og:image' />

      <meta content={TWITTER_CARD} name='twitter:card' />
      <meta content={TWITTER_HANDLE} name='twitter:site' />
      <meta content={chapter.title} name='twitter:title' />
      <meta content={chapter.abstract} name='twitter:description' />
      <meta content={chapter.videoThumbUrl} name='twitter:image' />
    </Head>
  )
}

export default Meta
